import { useNavigate } from 'react-router-dom';
import { formatarMoeda } from '../../lib/format';
import { useCarrinho } from './carrinho';
import { X, Minus, Plus, Trash2, ShoppingBag, ArrowRight } from 'lucide-react';

export function CarrinhoDrawer() {
  const { itens, aberto, setAberto, remover, atualizarQuantidade, total } = useCarrinho();
  const navigate = useNavigate();

  if (!aberto) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div
        className="absolute inset-0 bg-ink-950/50 backdrop-blur-sm animate-fade-in"
        onClick={() => setAberto(false)}
      />
      <aside className="absolute right-0 top-0 bottom-0 w-full max-w-md bg-white shadow-modal flex flex-col animate-fade-in">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-ink-100">
          <h2 className="font-display text-lg font-bold text-ink-950 flex items-center gap-2.5">
            <ShoppingBag className="w-5 h-5 text-brand-600" />
            Seu carrinho
          </h2>
          <button onClick={() => setAberto(false)} className="icon-btn" aria-label="Fechar">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Itens */}
        <div className="flex-1 overflow-y-auto px-6 py-4">
          {itens.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-center">
              <div className="w-14 h-14 rounded-2xl bg-ink-100 flex items-center justify-center mb-4">
                <ShoppingBag className="w-7 h-7 text-ink-300" />
              </div>
              <p className="text-sm font-semibold text-ink-700">Carrinho vazio</p>
              <p className="text-[13px] text-ink-400 mt-1">Escolha uma peça e monte do seu jeito.</p>
              <button onClick={() => setAberto(false)} className="btn-secondary mt-5">
                Ver produtos
              </button>
            </div>
          ) : (
            <div className="divide-y divide-ink-100">
              {itens.map(item => (
                <div key={item.chave} className="py-4 flex gap-4">
                  {/* Miniatura */}
                  <div className="w-16 h-16 rounded-xl bg-ink-100 overflow-hidden shrink-0 flex items-center justify-center">
                    {item.estampaImagem ? (
                      <img src={item.estampaImagem} alt="" className="w-full h-full object-cover" />
                    ) : (
                      <span
                        className="w-8 h-8 rounded-full ring-1 ring-inset ring-black/10"
                        style={{ backgroundColor: item.corHex || '#999' }}
                      />
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-ink-900 truncate">{item.produtoNome}</p>
                    <p className="text-xs text-ink-500 mt-0.5">
                      {item.cor} · {item.tamanho}
                      {item.estampaNome ? ` · ${item.estampaNome}` : ' · Lisa'}
                    </p>
                    <div className="flex items-center justify-between mt-2">
                      <div className="flex items-center gap-1">
                        <button
                          onClick={() => atualizarQuantidade(item.chave, item.quantidade - 1)}
                          className="w-7 h-7 rounded-lg border border-ink-200 flex items-center justify-center text-ink-500 hover:bg-ink-50"
                        >
                          <Minus className="w-3.5 h-3.5" />
                        </button>
                        <span className="w-8 text-center text-sm font-bold">{item.quantidade}</span>
                        <button
                          onClick={() => atualizarQuantidade(item.chave, item.quantidade + 1)}
                          className="w-7 h-7 rounded-lg border border-ink-200 flex items-center justify-center text-ink-500 hover:bg-ink-50"
                        >
                          <Plus className="w-3.5 h-3.5" />
                        </button>
                      </div>
                      <p className="text-sm font-bold text-ink-900">
                        {formatarMoeda(item.valorUnitario * item.quantidade)}
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={() => remover(item.chave)}
                    className="icon-btn self-start hover:!bg-red-50 hover:!text-red-600"
                    title="Remover"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        {itens.length > 0 && (
          <div className="border-t border-ink-100 px-6 py-5 space-y-4">
            <div className="flex items-center justify-between">
              <p className="text-sm text-ink-500">Subtotal</p>
              <p className="font-display text-xl font-bold text-ink-950">{formatarMoeda(total)}</p>
            </div>
            <button
              onClick={() => { setAberto(false); navigate('/loja/checkout'); }}
              className="btn-primary w-full !py-3.5 text-[15px]"
            >
              Finalizar pedido
              <ArrowRight className="w-5 h-5" />
            </button>
            <p className="text-center text-2xs text-ink-400">
              Pagamento por PIX ou cartão de crédito na próxima etapa.
            </p>
          </div>
        )}
      </aside>
    </div>
  );
}
